import { fetchApi } from '../api/digitalVault';
import { parseFileContainer, parseUserResponse } from '../utils';
const fetchUserMusicArtists = async (params = {}, logger) => {
    const { artistsHolder } = await fetchApi(params, 'browse/audio/artist', {}, false, logger);
    const cursor = artistsHolder.cursor?.$;
    return parseUserResponse(cursor, { file: parseFileContainer(artistsHolder.artists.artist) }, () => fetchUserMusicArtists(cursor ? { cursor } : params, logger));
};
export default fetchUserMusicArtists;
